import React, { useState, useEffect, useRef } from 'react';
import { combineClassNames } from '../../../core/css';

const CrossfadeImage = ({
  src,
  containerClass = '',
  imageClass = '',
  duration = 500,
  timingFunction = 'ease',
  delay = 0,
  alt,
  onClick,
}) => {
  const [topSrc, setTopSrc] = useState(src);
  const [bottomOpacity, setBottomOpacity] = useState(0);
  const [bottomSrc, setBottomSrc] = useState(src);
  const [blinkSrc, setBlinkSrc] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (blinkSrc) {
      setBlinkSrc(false);
    } else {
      if (topSrc !== src) {
        setBottomSrc(topSrc);
        setTopSrc(src);
        setBottomOpacity(0.99);

        if (!timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => setBottomOpacity(0), 20);
      }
    }
  }, [blinkSrc]);

  useEffect(() => {
    if (topSrc !== src) {
      setBlinkSrc(true);
    }
  }, [src]);

  return (
    <div
      className={combineClassNames([
        'crossfade-image-container',
        containerClass,
        imageClass,
      ])}
      onClick={onClick}>
      {topSrc && !blinkSrc && (
        <img
          className={combineClassNames('crossfade-image', imageClass)}
          src={topSrc}
          alt={alt}
        />
      )}
      {bottomSrc && !blinkSrc && (
        <img
          className={imageClass}
          style={{
            opacity: bottomOpacity,
            transition: `opacity ${duration / 1000}s ${timingFunction} ${
              delay / 1000
            }s`,
          }}
          src={bottomSrc}
          alt={alt}
        />
      )}
    </div>
  );
};

export default CrossfadeImage;
